import { useQuery } from '@tanstack/react-query';
import { api } from 'src/common/utils/api';
import type { CalendarEvent } from 'src/meetings/models';

export type FamilyMeeting = CalendarEvent;

export const useFamilyMeetings = (familyId: string | undefined) => {
  const resource = familyId ? `families/${familyId}/calendar-events` : '';

  const { data, isLoading, error } = useQuery({
    queryKey: ['families', familyId, 'calendar-events'],
    queryFn: () => api.getPaginated<FamilyMeeting>(resource, { page: 1, size: 100 }),
    enabled: !!familyId,
  });

  return {
    events: data?.items ?? [],
    isLoading,
    error,
  };
};
